import React, {Component} from "react";
import {AuthProvider} from "./context/authContext";
import config from "./config";

class Auth extends Component {
  state = {
    authenticated: false,
    user: {},
    access: [],
    is_admin: false,
    prop: {}
  };

  componentDidMount() {
    const usuario = localStorage.getItem('usuario');
    if (usuario) {
      this.setUser(JSON.parse(usuario))
    }
    document.title = config.SITE_TITLE
  }

  initiateLogin = ({ authenticated, prop, access, is_admin }) => {
    this.setState({ authenticated, prop, access, is_admin });
  };

  logout = () => {
    const usuario = localStorage.getItem('usuario');
    if (usuario) {
      localStorage.removeItem('usuario');
    }
    this.setState({ authenticated: false, user: {},  });
  };

  setUser = (user) => {
    localStorage.setItem('usuario', JSON.stringify(user));
    this.setState({ user })
  }

  hasAccess = (access) => {
    if(this.state.is_admin) { return true }
    if (Array.isArray(access)) {
      return this.state.access.some(a => access.includes(a))
    }
    return this.state.access.includes(access);
  }

  render() {
    const authProviderValue = {
      ...this.state,
      initiateLogin: this.initiateLogin,
      logout: this.logout,
      setUser: this.setUser,
      hasAccess: this.hasAccess,
    };
    return (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    );
  }
}

export default Auth;